import React from "react";
import { useTranslation } from "react-i18next";
import ToolTip from "../../../parts/tooltip";
import SvgIcon from "../../../parts/SvgIcon";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { renderToStaticMarkup } from "react-dom/server";
import { PushDailyDashboardDefaults } from "./push-preferences/daily-dashboard/PushDailyDashboardDefaults";
import { PushPressCommunityCardActionsComponent } from "./push-preferences/PushPressCommunityCardActionsComponent";

const placeholders = {
  global: `
  <script src="https://yourcdn.script.com/script.js"></script>
  <script>scriptFunction(new Date());</script>`,
  paymentSuccess: ` 
  gtag("event", "conversion", {
    send_to: "AW-YYYYY/XXXXX",
    unit_amount: %PRICE%,
    interval: %INTERVAL%,
    email: %EMAIL%,
  });`,
};
const PushPreferences = ({ locals, userToSendInformation, onFormChange }) => {
  const { t } = useTranslation("dashboard");
  const { activeUser, organizationOwner } = locals;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const { customBranding = {}, pushAccountInfo = {} } = userToRequest;
  const { communityLink = "" } = customBranding;
  const initialState = {
    global: customBranding?.storefrontSnippets?.global
      ? customBranding.storefrontSnippets.global
      : "",
    paymentSuccess: customBranding?.storefrontSnippets?.paymentSuccess
      ? customBranding.storefrontSnippets.paymentSuccess
      : "",
  };

  const [state, setState] = React.useState(initialState);

  const handleChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
  };

  const renderGlobalTooltip = () => {
    return (
      <ToolTip
        id="global-tooltip"
        body={[t("pushPreferences.globalTooltip")]}
      >
        <SvgIcon className="help-icon" src="/img/svg/question-circle.svg" />
      </ToolTip>
    );
  };

  const renderPaymentTooltip = () => {
    return (
      <ToolTip
        id="payment-tooltip"
        html={renderToStaticMarkup(
          <div className="paymentSucess-tooltip">
            <p>{t("pushPreferences.paymentTooltipIntro")}</p>
            <p>{t("pushPreferences.paymentTooltipExample")}</p>
            <p>{`gtag("event", "conversion", {`}</p>
            <p>send_to: "AW-YYYYYY/XXXXX",</p>
            <p>
              unit_amount: <span style={{ color: "green" }}>%PRICE%</span>,{" "}
            </p>
            <p>
              interval: <span style={{ color: "green" }}>%INTERVAL%</span>,{" "}
            </p>
            <p>
              email: <span style={{ color: "green" }}>%EMAIL%</span>,
            </p>
            <p>{`});`}</p>
            <p>
              <span style={{ color: "green" }}>
                {t("pushPreferences.greenPlaceholder")}
              </span>
            </p>
          </div>
        )}
      >
        <SvgIcon className="help-icon" src="/img/svg/question-circle.svg" />
      </ToolTip>
    );
  };

  return (
    <form
      id="form-push"
      method="POST"
      encType="multipart/form-data"
      data-noreset
      className="push"
      onChange={onFormChange}
    >
      <input
        type="hidden"
        name="userToSendInformation"
        defaultValue={userToSendInformation}
      />
      <div className="push-community">
        <div className="push-community-card">
          <div className="push-community-card-info">
            <span>{t("pushPreferences.inAppCommunity")}</span>
          </div>
          <PushPressCommunityCardActionsComponent
            accountInfo={pushAccountInfo}
            useLink={false}
            option="inAppCommunityEnabled"
            tooltip={t("pushPreferences.inAppCommunityTooltip")}
          />
        </div>
        <div className="push-community-card">
          <div className="push-community-card-info">
            <span>{t("pushPreferences.externalCommunity")}</span>
          </div>
          <PushPressCommunityCardActionsComponent
            accountInfo={pushAccountInfo}
            communityLinkFromDb={communityLink}
            useLink={true}
            option="externalCommunityEnabled"
            tooltip={t("pushPreferences.externalCommunityTooltip")}
          />
        </div>
      </div>
      {locals.pushDashboardDefaults && (
        <PushDailyDashboardDefaults
          data={locals.pushDashboardDefaults}
          onFormChange={onFormChange}
        />
      )}
      <h4 className="mb-3">{t("pushPreferences.storefrontIntegrations")}</h4>
      <p className="p2">{t("pushPreferences.storefrontIntegrationsIntro")}</p>
      <p className="p2 mb-12">{t("pushPreferences.contactBeforeAdding")}</p>
      <h4 className="mb-6">{t("pushPreferences.snippets")}</h4>
      <label>
        {t("pushPreferences.globalSiteSnippet")}
        {renderGlobalTooltip()}
      </label>
      <textarea
        name="global"
        className="textarea-input min-h-48 mb-8"
        placeholder={placeholders.global}
        value={state.global}
        onChange={handleChange}
      />
      <label>
        {t("pushPreferences.paymentSuccessSnippet")}
        {renderPaymentTooltip()}
      </label>
      <textarea
        name="paymentSuccess"
        className="textarea-input min-h-48"
        placeholder={placeholders.paymentSuccess}
        value={state.paymentSuccess}
        onChange={handleChange}
      />
      <div className="only-show-mobile" role="separator-line" />
      <label className="mt-16 mobile-hidden">
        {t("pushPreferences.placeholdersLabel")}
      </label>
      <p className="chip info mb-2">{t("pushPreferences.placeholderPrice")}</p>{" "}
      <p className="chip info mb-2">
        {t("pushPreferences.placeholderInterval")}
      </p>{" "}
      <p className="chip info mb-2">{t("pushPreferences.placeholderEmail")}</p>{" "}
      <p className="p4 mb-6">{t("pushPreferences.placeholdersUsage")}</p>
      <p>
        <span className="chip warning">
          {t("pushPreferences.scriptWarning")}
        </span>
      </p>
    </form>
  );
};
export default PushPreferences;
